import React from 'react'
import { getProductTag } from '@helpers/products'
import { PRODUCT_COLOUR_TAGS } from '@consts/index'
import Badge from '@components/ui/Badge'
import colours from './colours.module.scss'
import styles from './styles.module.scss'

type ColorInfoProps = {
  customTag?: string
  productColor: string
  productTags: string[]
}

export const ColorInfoTag = ({
  productTags,
  customTag
}: Omit<ColorInfoProps, 'productColor'>) => {
  const tagInfo = getProductTag(productTags, PRODUCT_COLOUR_TAGS)

  const badgeColor =
    tagInfo && /Low/.test(tagInfo?.formatted) ? colours.color1 : colours.color2
  return customTag || tagInfo ? (
    <div className={styles.productForm__colorBadge}>
      {' '}
      <Badge
        medium
        badgeType="minimal"
        themeColour={badgeColor}
        title={customTag || tagInfo?.formatted || ''}
      />
    </div>
  ) : null
}

const ColorInfo = ({
  productColor,
  productTags,
  customTag
}: ColorInfoProps) => (
  <h2 className={styles.productForm__color}>
    {productColor}
    <ColorInfoTag productTags={productTags} customTag={customTag} />
  </h2>
)

export default ColorInfo
